import Calculator from "@/components/Calculator"
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import {Info} from 'lucide-react'

function OpalCalculator() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-orange-50">
      <Header />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            Opal Carat Weight Calculator
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Calculate opal carat weight and value. Professional tool for opal weight estimation.
          </p>
        </div>

        <div className="mb-12">
          <Calculator 
            defaultGemstone="opal"
            title="Opal Weight & Value Calculator"
            description="Specialized calculator for opal gemstones (SG: 2.15)"
          />
        </div>

        <div className="bg-white rounded-xl shadow-lg border border-orange-100 p-8">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <Info className="w-6 h-6 text-orange-600" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">About Opal Gemstones</h2>
              <p className="text-gray-600 mb-4">
                Opals are unique gemstones known for their play-of-color phenomenon. With a specific gravity of 2.15, opals are among the lightest gemstones. They contain water and require special care. October's birthstone comes in many varieties.
              </p>
              <h3 className="font-bold text-gray-900 mb-2">Opal Value Factors:</h3>
              <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4">
                <li><strong>Play of Color:</strong> Vibrant, multi-color flashes are most valuable</li>
                <li><strong>Body Tone:</strong> Black opals command the highest prices</li>
                <li><strong>Pattern:</strong> Harlequin and ribbon patterns are prized</li>
                <li><strong>Origin:</strong> Australian opals (especially Lightning Ridge) are top-tier</li>
                <li><strong>Type:</strong> Precious opal vs common opal affects value significantly</li>
              </ul>
              <p className="text-gray-600 mt-4">
                Our opal calculator helps you estimate the carat weight and approximate price range for your opal gemstones based on their dimensions.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default OpalCalculator
